/**
 * Immutable, layout-neutral plain-text projection. Rich presentation is a separate contribution.
 */
export type TextReadContent = {
  readonly kind: 'text';
  readonly text: string;
};

export const EMPTY_TEXT_CONTENT: TextReadContent = Object.freeze({
  kind: 'text',
  text: ''
});
